import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=f4477050&scoped=true&"
import script from "./Main.vue?vue&type=script&lang=js&"
export * from "./Main.vue?vue&type=script&lang=js&"
import style0 from "./Main.vue?vue&type=style&index=0&id=f4477050&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4477050",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\job_hymn\\hymn-business02\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4477050')) {
      api.createRecord('f4477050', component.options)
    } else {
      api.reload('f4477050', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=f4477050&scoped=true&", function () {
      api.rerender('f4477050', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/confirm/Main.vue"
export default component.exports